import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  hero: {
    padding: ({ secondary }) =>
      secondary ? theme.spacing(4) : theme.spacing(12, 4),
    height: ({ secondary }) => (secondary ? 'auto' : '100vh'),
    backgroundPosition: 'bottom',
    backgroundSize: 'cover',
    opacity: '1 !important',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: ({ secondary }) => (secondary ? 'center' : 'flex-start'),
    alignItems: ({ secondary }) => (secondary ? 'center' : 'flex-start'),
    textAlign: ({ secondary }) => (secondary ? 'center' : 'left'),
    backgroundColor: ({ darker }) =>
      darker
        ? theme.palette.background.lightOverlay
        : theme.palette.background.extraLightOverlay,
  },

  mainPageText: {
    fontSize: theme.typography.h3.fontSize,
    fontWeight: ({ secondary }) =>
      secondary
        ? theme.typography.fontWeightLight
        : theme.typography.fontWeightBold,
    fontFamily: 'Roboto Condensed',
    textTransform: 'uppercase',
    letterSpacing: ({ secondary }) =>
      secondary ? theme.typography.letterSpacing : '',
    color: ({ secondary }) =>
      secondary ? theme.palette.text.white : theme.palette.text.mainAlternative,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.h1.fontSize,
    },
  },

  secondaryPageText: {
    fontSize: theme.typography.h6.fontSize,
    color: ({ secondary }) =>
      secondary ? theme.palette.text.white : theme.palette.text.disabled,
    fontStyle: 'italic',
    fontFamily: 'Roboto Condensed',
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.h4.fontSize,
    },
  },
}))
